import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Setting Up OpenSearch Dashboard Index Patterns",
  "description": "Learn how to create and configure index patterns in OpenSearch Dashboard for your AWS managed OpenSearch cluster"
};
export let structuredData = {
  "contents": [{
    "heading": "prerequisites",
    "content": "OpenSearch Managed Cluster"
  }, {
    "heading": "how-to",
    "content": "Go to OpenSearch Console from your logged in aws console."
  }, {
    "heading": "how-to",
    "content": "Under Managed Clusters, click on dashboard."
  }, {
    "heading": "how-to",
    "content": "Select the cluster you want to setup dashboard for."
  }, {
    "heading": "how-to",
    "content": "Then you will get dashboard url. During initial setup, you will have set username and password. Use that or click on actions and edit security config for master user."
  }, {
    "heading": "how-to",
    "content": "Once in, first create the indexes that you want to show through dashboard."
  }, {
    "heading": "how-to",
    "content": "Click on Dashboard Management"
  }, {
    "heading": "how-to",
    "content": "Click on Create Index Pattern"
  }, {
    "heading": "how-to",
    "content": "Create your index, you will see your already predefined indexes, and select by timestamp."
  }, {
    "heading": "how-to",
    "content": "Thats it, go to dashboard, create seperate dashboard folders, select the type of dashboard you want and so on."
  }],
  "headings": [{
    "id": "prerequisites",
    "content": "Prerequisites"
  }, {
    "id": "how-to",
    "content": "How to?"
  }]
};
export const toc = [{
  depth: 2,
  url: "#prerequisites",
  title: _jsx(_Fragment, {
    children: "Prerequisites"
  })
}, {
  depth: 2,
  url: "#how-to",
  title: _jsx(_Fragment, {
    children: "How to?"
  })
}];
function _createMdxContent(props) {
  const _components = {
    h2: "h2",
    li: "li",
    ol: "ol",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "prerequisites",
      children: "Prerequisites"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "OpenSearch Managed Cluster"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "how-to",
      children: "How to?"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "Go to OpenSearch Console from your logged in aws console."
      }), "\n", _jsx(_components.li, {
        children: "Under Managed Clusters, click on dashboard."
      }), "\n", _jsx(_components.li, {
        children: "Select the cluster you want to setup dashboard for."
      }), "\n", _jsx(_components.li, {
        children: "Then you will get dashboard url. During initial setup, you will have set username and password. Use that or click on actions and edit security config for master user."
      }), "\n", _jsxs(_components.li, {
        children: ["Once in, first create the indexes that you want to show through dashboard.", "\n", _jsxs(_components.ol, {
          children: ["\n", _jsx(_components.li, {
            children: "Click on Dashboard Management"
          }), "\n", _jsx(_components.li, {
            children: "Click on Create Index Pattern"
          }), "\n", _jsx(_components.li, {
            children: "Create your index, you will see your already predefined indexes, and select by timestamp."
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.li, {
        children: "Thats it, go to dashboard, create seperate dashboard folders, select the type of dashboard you want and so on."
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
